<template>
  <div class="__container">
    <div class="_row">
      <div class="_img" data-aos="fade-right"><img :src="data.bizKimizImage || require('../../assets/images/sosyalalan.jpeg')" alt="" /></div>
      <div class="info">
        <h2 class="about">Biz Kimiz?</h2>
        <p class="info1" v-for="(paragraph, idx) in formattedText" :key="idx">{{ paragraph }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { data: { type: Object, required: true } },
  computed: { formattedText() { return this.data.bizKimizText ? this.data.bizKimizText.split('\n').filter(p => p.trim() !== '') : ['Bilgiler yükleniyor...']; } }
};
</script>

<style scoped>
.__container { width: 100%; background-color: #ededed; padding: 4%; display: flex; justify-content: center; }
._row { display: flex; flex-direction: row; width: 100%; max-width: 1900px; }
._img { width: 90%; justify-content: center; margin-right: 50px; }
._img img { width: 100%; height: auto; object-fit: cover; }
.info { width: 100%; padding-right: 3%; padding-top: 3%; display: flex; flex-direction: column; color: black; font-family: "DM Sans", sans-serif; }
.info p { margin: 0; padding-bottom: 30px; font-size: 18px; color: #656565; }
.about { font-size: 40px; padding-bottom: 20px; }
.info1 { padding-bottom: 25px; font-size: 16px; }
@media screen and (max-width: 1023px) { ._row { flex-direction: column; } ._img { width:100%; margin-right:0; padding:0 0 20px 0; } }
</style>